// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"7929d755","107":"f0ac587f","252":"c3ee6bb7","272":"6e2f3d3f","453":"0c96483e","488":"8b5de871","592":"598474ff","676":"0ce0c9fa","706":"f347f9b7","713":"33ca7679","900":"6f96fe78","933":"87994661"}[chunkId] + ".chunk.js";
};